// src/utils/placeholders.js
// Inline SVG placeholders — koi file server par rakhne ki zaroorat nahi,
// isliye ye kabhi 404 / index.html nahi de sakte aur onError loop nahi banta.

const buildPlaceholder = (label) =>
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    "<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'>" +
      "<rect width='200' height='200' fill='#f0f4f2'/>" +
      "<text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' " +
      "font-family='Arial, sans-serif' font-size='16' fill='#9aa8a0'>" +
      label +
      "</text></svg>",
  );

export const PLACEHOLDER_PRODUCT = buildPlaceholder("No image");
export const PLACEHOLDER_SHOP = buildPlaceholder("No logo");
